export default __webpack_public_path__ + "static/media/hyresvillkor.5f2974ef.pdf";